<template>
  <ClientLedger
    title="Client Account Ledger"
    @componentLedgerBack="componentParent"
    url="contact/report/ledger-account"
  />
</template>

<script>
import ClientLedger from './ComponentClientLedger'
export default {
  components: {
    ClientLedger
  },
  methods: {
    componentParent(component){
      this.$emit('changeTab',component)
    }
  }
}
</script>
<style>
@import "../../style/style.css";
</style>
